import React from "react";

// Button Loading Component
export const LoadingButton = ({ 
  children, 
  isLoading = false, 
  loadingText = "Loading...", 
  className = "", 
  disabled = false,
  ...props 
}) => {
  return (
    <button 
      className={`${className} ${isLoading ? 'loading' : ''}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="loading-spinner" />
          {loadingText}
        </>
      ) : (
        children
      )}
    </button>
  );
};

// Skeleton Loading Component
export const Skeleton = ({ 
  width = "100%", 
  height = "20px", 
  borderRadius = "4px", 
  className = "" 
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        backgroundColor: '#f0f0f0',
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'loading 1.5s infinite',
      }}
    />
  );
};

// Card Loading Component
export const CardSkeleton = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="feature-card" style={{ padding: '40px 30px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
            <Skeleton width="80px" height="80px" borderRadius="20px" />
          </div>
          <Skeleton width="60%" height="24px" borderRadius="4px" style={{ margin: '0 auto 15px' }} />
          <Skeleton width="100%" height="16px" borderRadius="4px" style={{ marginBottom: '8px' }} />
          <Skeleton width="80%" height="16px" borderRadius="4px" style={{ marginBottom: '8px' }} />
          <Skeleton width="90%" height="16px" borderRadius="4px" />
        </div>
      ))}
    </>
  );
};

// Form Loading Component
export const FormSkeleton = () => {
  return (
    <div className="demo-form">
      <div className="form-grid">
        <div className="form-field">
          <Skeleton width="100px" height="16px" style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height="51px" borderRadius="12px" />
        </div>
        <div className="form-field">
          <Skeleton width="120px" height="16px" style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height="51px" borderRadius="12px" />
        </div>
        <div className="form-field">
          <Skeleton width="110px" height="16px" style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height="51px" borderRadius="12px" />
        </div>
        <div className="form-field">
          <Skeleton width="140px" height="16px" style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height="51px" borderRadius="12px" />
        </div>
        <div className="form-field full">
          <Skeleton width="130px" height="16px" style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height="120px" borderRadius="12px" />
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Skeleton width="200px" height="56px" borderRadius="50px" />
      </div>
    </div>
  );
};

// Loading Spinner Component
export const LoadingSpinner = ({ size = "24px", color = "#4facfe" }) => {
  return (
    <div
      className="loading-spinner"
      style={{
        width: size,
        height: size,
        border: `2px solid #f3f3f3`,
        borderTop: `2px solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
  );
};

// Section Loading Component
export const SectionLoading = ({ title, description }) => {
  return (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
      <Skeleton width="300px" height="48px" borderRadius="4px" style={{ margin: '0 auto 60px' }} />
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Skeleton width="100%" height="20px" borderRadius="4px" style={{ marginBottom: '10px' }} />
        <Skeleton width="80%" height="20px" borderRadius="4px" style={{ marginBottom: '10px' }} />
        <Skeleton width="90%" height="20px" borderRadius="4px" />
      </div>
    </div>
  );
};

// Portal Card Loading Component
export const PortalCardSkeleton = ({ count = 2 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="portal-card" style={{ padding: '50px 40px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
            <Skeleton width="100px" height="100px" borderRadius="25px" />
          </div>
          <Skeleton width="60%" height="32px" borderRadius="4px" style={{ margin: '0 auto 20px' }} />
          <Skeleton width="100%" height="18px" borderRadius="4px" style={{ marginBottom: '8px' }} />
          <Skeleton width="90%" height="18px" borderRadius="4px" style={{ marginBottom: '30px' }} />
          
          {/* Features list skeleton */}
          <div style={{ textAlign: 'left', marginBottom: '35px' }}>
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <Skeleton width="16px" height="16px" borderRadius="2px" style={{ marginRight: '10px' }} />
                <Skeleton width="80%" height="16px" borderRadius="4px" />
              </div>
            ))}
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <Skeleton width="200px" height="50px" borderRadius="50px" />
          </div>
        </div>
      ))}
    </>
  );
};